(function () {
  var userOpenedWidget = false;
  var suppressedElements = [];
  var launcherSelector = [
    '#ShopifyChat',
    '#smile-ui-lite-launcher-frame-container',
    '#smile-lite-launcher-frame',
    'salesmartly-chat-widget',
    '[id*="smile" i]',
    '[class*="smile" i]',
    '[id*="salesmartly" i]',
    '[class*="salesmartly" i]',
    '[src*="salesmartly" i]',
    '[id*="shopify-chat" i]',
    '[class*="shopify-chat" i]'
  ].join(',');
  var ignoredSelector = [
    '#shopify-pc__banner',
    '#PBarNextFrameWrapper',
    '#PBarNextFrame',
    '[id*="cookie" i]',
    '[class*="cookie" i]',
    '[id*="privacy" i]',
    '[class*="privacy" i]',
    '[class*="cart" i]',
    '[id*="cart" i]',
    '[aria-modal="true"]'
  ].join(',');

  function getPath(event) {
    if (event.composedPath) {
      return event.composedPath();
    }

    var path = [];
    var node = event.target;

    while (node) {
      path.push(node);
      node = node.parentNode || node.host;
    }

    return path;
  }

  function matches(element, selector) {
    return element && element.nodeType === 1 && element.matches(selector);
  }

  function markUserOpened(event) {
    var path = getPath(event);

    for (var index = 0; index < path.length; index += 1) {
      if (matches(path[index], launcherSelector)) {
        userOpenedWidget = true;
        document.documentElement.classList.add('chicchok-widget-user-opened');
        restoreSuppressedElements();
        return;
      }
    }
  }

  function restoreSuppressedElements() {
    suppressedElements.forEach(function (entry) {
      if (!entry.element || !entry.element.isConnected) {
        return;
      }

      if (entry.displayPriority) {
        entry.element.style.setProperty('display', entry.displayValue || '', entry.displayPriority);
      } else {
        entry.element.style.display = entry.displayValue || '';
      }

      if (entry.visibilityPriority) {
        entry.element.style.setProperty('visibility', entry.visibilityValue || '', entry.visibilityPriority);
      } else {
        entry.element.style.visibility = entry.visibilityValue || '';
      }

      entry.element.removeAttribute('data-chicchok-autopopup-suppressed');
    });

    suppressedElements = [];
  }

  function closeShopifyInbox() {
    var chat = document.getElementById('ShopifyChat');

    if (!chat || !chat.shadowRoot) {
      return;
    }

    var toggle = chat.shadowRoot.querySelector('[data-spec="toggle-button"], .chat-toggle');

    if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
      toggle.click();
    }
  }

  function isWidgetPanel(element) {
    if (!element || matches(element, ignoredSelector)) {
      return false;
    }

    var identity = [
      element.tagName || '',
      element.id || '',
      element.className || '',
      element.getAttribute('src') || '',
      element.getAttribute('title') || '',
      element.getAttribute('aria-label') || ''
    ].join(' ');
    var text = (element.innerText || element.textContent || '').replace(/\s+/g, ' ').trim();

    if (
      !/(smile|salesmartly|shopify.?chat|inbox|loyalty|reward|chat)/i.test(identity)
      && !/(Binding is freedom|Shipping & Delivery|Order Tracking|Craftsmanship|Size & Material|Speak to Creator|navigate our studio)/i.test(text)
    ) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    var isPanelSize = rect.width > 110 && rect.height > 110;
    var isFloating = style.position === 'fixed' || style.position === 'absolute' || Number(style.zIndex) > 1000;

    return isPanelSize && isFloating;
  }

  function suppressElement(element) {
    if (!element || element.getAttribute('data-chicchok-autopopup-suppressed') === 'true') {
      return;
    }

    suppressedElements.push({
      element: element,
      displayValue: element.style.display,
      displayPriority: element.style.getPropertyPriority('display'),
      visibilityValue: element.style.visibility,
      visibilityPriority: element.style.getPropertyPriority('visibility')
    });

    element.setAttribute('data-chicchok-autopopup-suppressed', 'true');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
  }

  function suppressAutoOpenedPanels() {
    if (userOpenedWidget) {
      return;
    }

    closeShopifyInbox();

    document.querySelectorAll('body *').forEach(function (element) {
      if (isWidgetPanel(element)) {
        suppressElement(element);
      }
    });
  }

  document.addEventListener('pointerdown', markUserOpened, true);
  document.addEventListener('click', markUserOpened, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', suppressAutoOpenedPanels);
  } else {
    suppressAutoOpenedPanels();
  }

  window.addEventListener('load', suppressAutoOpenedPanels);

  var observer = new MutationObserver(function () {
    window.requestAnimationFrame(suppressAutoOpenedPanels);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'aria-expanded']
  });

  [250, 750, 1500, 3000, 6000, 10000].forEach(function (delay) {
    window.setTimeout(suppressAutoOpenedPanels, delay);
  });
})();
